import React, { useState, useEffect } from "react"
import { scroll, scrollActive } from "./scroll.css"
import { Button } from "./ui"
import { ChevronUp } from "react-feather"

const Scroll = ({ showBelow }) => {
  const [show, setShow] = useState(showBelow ? false : true)

  const handleScroll = () => {
    if (window.pageYOffset > showBelow) {
      if (!show) setShow(true)
    } else {
      if (show) setShow(false)
    }
  }

  const handleClick = (e) => {
    e.preventDefault()
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  useEffect(() => {
    if (showBelow) {
      window.addEventListener(`scroll`, handleScroll)
      return () => window.removeEventListener(`scroll`, handleScroll)
    }
  })

  return (
    <div>
      <Button
        onClick={handleClick}
        className={show ? scrollActive : scroll}
        aria-label="to top"
        component="span"
      >
        <ChevronUp size={24} color={"white"} />
      </Button>
    </div>
  )
}

export default Scroll
